import Vue from 'vue'
import Meta from 'vue-meta'
import Router from 'vue-router'
import auth from './auth'
import store from '../store'
import { endsWith } from 'lodash'

import routes from 'app/.generated/routes'

Vue.use(Meta)
Vue.use(Router)

/**
 * Page
 * - Stores the current page data between router.beforeEach and router.afterEach
 * @type {Boolean,Object}
 */
let page = false

const router = new Router({
  mode: 'history',
  scrollBehavior,
  routes
})

/**
 * Before each route change
 * TODO:
 * - Prerender outputs a blank page for protected routes.
 */
router.beforeEach(async (to, from, next) => {
  /**
   * Catch non-slash routes
   */
  if (to.name === 'not-found' && !endsWith(to.path, '/')) {
    // Try path with slash
    return next({ path: to.path + '/' })
  }

  /**
   * Authentication for protected routes
   */
  if (!auth.checkRoute(to)) {
    return next({ name: 'login' })
  }

  // Vue.prototype.$Progress.start()

  /**
   * Fetch page content
   * - Don't handle the error if a content file is not found for the path.
   */
  try {
    page = await Vue.prototype.$page.get(to.path)
  } catch (err) {}

  next()
})

/**
 * After each route change
 */
router.afterEach((to, from) => {
  if (!to.meta.preload) {
    // Vue.prototype.$Progress.finish()
  }

  if (page) {
    store.dispatch('setCurrentPage', page)
    page = false
  } else {
    store.dispatch('clearCurrentPage')
  }

  // Signal to prerender server that the page should be ready to render
  setTimeout(() => {
    window.prerenderReady = true
  }, 1000)
})

/**
 * Handle scroll behavior
 */
function scrollBehavior (to, from, savedPosition) {
  // Simulate native back/forward button behavior
  if (savedPosition) return savedPosition

  if (to.path !== from.path) {
    return { x: 0, y: 0 }
  }

  // NOTE: If we reenable this, make sure it works well with the Theater
  // series selector.
  // return { x: 0, y: 0 }
}

export default router



// WEBPACK FOOTER //
// ./app/src/router/index.js